const WEB_PORTAL = 'Web Portal';
const WEB_MAP = 'Web Map';
const EDOTCO_SITE= "E.Co Sites";
const OPERATOR_SITE = "Operator Sites";

export {
    WEB_PORTAL,
    WEB_MAP,
    EDOTCO_SITE,
    OPERATOR_SITE
}